import React, { useState } from "react"
import { Link } from "@quarkly/widgets"

const ProtectedEmail = ({ user, domain, children, ...props }) => {
  const [href, setHref] = useState("#")

  const handleInteraction = () => {
    if (href === "#") {
      setHref(`mailto:${user}@${domain}`)
    }
  }

  const handleClick = e => {
    e.preventDefault()
    window.location.href = `mailto:${user}@${domain}`
  }

  return (
    <Link
      href={href}
      onMouseEnter={handleInteraction}
      onFocus={handleInteraction}
      onClick={handleClick}
      {...props}
    >
      {children || (
        <>
          <span>{user}</span>
          <span style={{ display: "none" }}>-spam-</span>
          <span>&#64;</span>
          <span style={{ display: "none" }}>-free-</span>
          <span>{domain}</span>
        </>
      )}
    </Link>
  )
}

export default ProtectedEmail
